import React from "react";
import { TextField, TextFieldProps } from "@material-ui/core";
import { useController, Control } from "react-hook-form";

type Props = {
  name: string;
  label?: string;
  control?: Control<any>; // optional when used from provider
  textFieldProps?: TextFieldProps;
};
export const TextFieldController = ({ name, label, textFieldProps, control }: Props) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control
  });

  return (
    <TextField
      {...field}
      label={label}
      error={invalid} // Set error prop based on validation
      helperText={error?.message || textFieldProps?.helperText}
      {...textFieldProps}
    />
  );
};

export default TextFieldController;
